import script from "./EditableContent.vue?vue&type=script&lang=ts"
export * from "./EditableContent.vue?vue&type=script&lang=ts"

import "./EditableContent.vue?vue&type=style&index=0&id=9e8cc8b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e8cc8b0"]])

export default __exports__